/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export enum TemplateJobStatus {
    CANCELED = 'CANCELED',
    COMPLETED = 'COMPLETED',
    CREATE_FAILED = 'CREATE_FAILED',
    CREATE_IN_PROGRESS = 'CREATE_IN_PROGRESS',
    DELETED = 'DELETED',
    DELETE_FAILED = 'DELETE_FAILED',
    DELETE_IN_PROGRESS = 'DELETE_IN_PROGRESS',
    FAILED = 'FAILED',
    IN_PROGRESS = 'IN_PROGRESS',
    SNAPSHOT_COMPLETED = 'SNAPSHOT_COMPLETED',
    SNAPSHOT_FAILED = 'SNAPSHOT_FAILED',
    SNAPSHOT_IN_PROGRESS = 'SNAPSHOT_IN_PROGRESS',
    UPDATED = 'UPDATED',
    UPDATE_FAILED = 'UPDATE_FAILED',
    UPDATE_IN_PROGRESS = 'UPDATE_IN_PROGRESS'
}
